import { Page_settings } from "@/config/page_settings";
import { deviceWidth } from "@/design/defaultTheme";
import { useWindowSize } from "@/hooks/useWindowSize";
import { rootStore } from "@/mobx/store";
import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Button from "@/components/button";
import colors from "@/design/colors";
import styled from "styled-components";
import BasicTable from "@/components/table/BasicTable";
import DeviceCreateModal from "./DeviceCreateModal";

const Device = () => {
  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */
  const context: any = useContext(Page_settings);
  const token = rootStore.getMe?.accessToken;
  const { width } = useWindowSize();
  const isMobile = width < deviceWidth.mobile;
  const navigate = useNavigate();

  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20; // 한 페이지당 보여줄 항목 수
  const [totalCount, setTotalCount] = useState(0);
  const { id } = useParams();
  const [deviceList, setDeviceList] = useState([]);
  const [isAddDeviceModalOpen, setAddDeviceModalOpen] = useState<boolean>(false);

  /* **********************************
   * Handler
   * 이벤트 핸들러
   ********************************** */

  const getDeviceList = async () => {
    context.post(
        `/office/getDeviceList`, 
        {
            storeId: parseInt(id),
            pageSize: pageSize,
            pageNumber: currentPage
        }, (response) => {
            setTotalCount(response.totalCount);
            setDeviceList(response.resultList);
        }
    )
  }

  const deleteDevice = async (catId: string, deviceId: string) => {
    context.post(
        `/office/deleteDeviceInfo`,
        {
            storeId: parseInt(id),
            catId,
            deviceId
        }, (response) => {
            getDeviceList()
        }
    )
  }

 /* **********************************
   * EFFECTS
   * 컴포넌트 상태 변경 처리
   ********************************** */
    useEffect(() => {
        getDeviceList();
    }, [currentPage, id]);

    // 데이터가 없을 경우 페이지 1로 설정
    useEffect(() => {
        if (totalCount === 0) setCurrentPage(1);
    }, [totalCount]);


    const deviceColumns = [
        {
            key: "id",
            header: "id",
            width: "90px",
            render: (item) => <span>{item.id}</span>
        },{
            key: "catId",
            header: "CAT ID",
            width: "60px",
            render: (item) => <span>{item.catId}</span>
        },
        {
          key: "delete",
          header: "삭제",
          width: "60px",
          render: (item) => {
            return (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {item.type === "OFFLINE" && (
                  <Button
                  text="삭제"
                  size="small"
                  width="30%"
                  height="28px"
                  buttonColor={colors.warning}
                  textColor={colors.white}
                  onClick={() => {
                    deleteDevice(item.catId, item.id);
                  }}
                />)}
              </div>
            )
          }
      }
    ]

    return (
        <Container>
          <Row>
            <Button
              text="기기 등록"
              size="small"
              width="fit-content"
              height="32px"
              buttonColor={colors.blue600}
              textColor={colors.white}
              customFontSize={isMobile ? "11px" : "13px"}
              style={{
                padding: "0 10px",
              }}
              onClick={() => setAddDeviceModalOpen(true)}
            />
          </Row>
          <BasicTable
              data={deviceList}
              columns={deviceColumns}
              rowKey="id"
              showCheckbox={false}
              emptyMessage="device 가 존재하지 않습니다."
              totalPages={Math.max(1, Math.ceil(totalCount / pageSize))}
              onPageChange={(page) => setCurrentPage(page)}
              showPagination={true}
              rowCursorPointer={false}
          />
            {isAddDeviceModalOpen && 
                <DeviceCreateModal 
                onClose={() => setAddDeviceModalOpen(false)}/>
            }
        </Container>
    )
}

export default Device;

const Container = styled.div`
  height: 100%
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
`
